import React from 'react';

import { Box } from '@chakra-ui/react';

import {
  OutlinedFormDisplayField,
  OutlinedFormFieldComponentProps,
} from '../types';

import { FieldContainer } from './FieldContainer';

export const DisplayField = ({
  field,
  styles,
}: OutlinedFormFieldComponentProps<OutlinedFormDisplayField>) => (
  <FieldContainer
    fieldStyles={field.styles}
    isDisabled={field.isDisabled}
    label={field.label}
    styles={styles}
  >
    <Box pt={2} {...styles?.value} {...field.styles?.value}>
      {field.value ?? field.placeholder}
    </Box>
  </FieldContainer>
);
